const STATIC_SECTION_TARGETS = ["technical-performance", "product-fabric", "product-description", "product-dimensions"];

// Utility: read products (handles) from the JSON script embedded by the block
/** @returns {{handle: string}[]} */
function loadStaticCompareProductsFromDOM() {
  const container = document.querySelector(
    ".static-compare-products-widget .compare-products-container"
  );
  if (!container) return [];

  const dataEl = container.querySelector(
    'script[type="application/json"][data-role="static-compare-products-data"]'
  );
  if (!dataEl) return [];

  try {
    const parsed = JSON.parse(dataEl.textContent.trim());
    // Expect an array like [{ handle: "..." }, ...]
    if (Array.isArray(parsed)) return parsed.filter(Boolean);
  } catch (_e) {
    // ignore
  }
  return [];
}

class StaticCompareProductCard extends HTMLElement {
  constructor() {
    super();
    this.index = Number(this.getAttribute("data-index") || 0);
  }

  connectedCallback() {
    const products = loadStaticCompareProductsFromDOM();
    const handle = products[this.index]?.handle;
    this.fetchAndRender(handle);
  }

  /**
   * @param {string | undefined} handle
   */
  fetchAndRender(handle) {
    if (!handle) {
      this.renderEmpty();
      return;
    }

    const url = `/products/${handle}?view=compare-product-card`;
    fetch(url)
      .then(async (response) => {
        const contentType = response.headers.get("content-type") || "";
        if (contentType.includes("application/json")) {
          const json = await response.json();
          return json?.main || "";
        }
        return response.text();
      })
      .then((html) => {
        if (!html) {
          this.renderEmpty();
          return;
        }

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const main_section = doc.querySelector(".compare-product-information");
        if (main_section && this.index === 0) {
          // Look for a button or link with class 'view-product-button' (Liquid template context)
          const viewBtn = main_section.querySelector(".view-product-button");
          if (viewBtn) {
            viewBtn.removeAttribute("href");
            viewBtn.setAttribute("aria-disabled", "true");
            viewBtn.textContent = "VIEWING";
            viewBtn.classList.add("viewing");
            viewBtn.style.pointerEvents = "none";
            viewBtn.style.cursor = "not-allowed";
            viewBtn.style.backgroundColor = "#1A19190A";
            viewBtn.style.color = "#1A1919";
            viewBtn.style.opacity = 1;
            viewBtn.style['box-shadow'] = 'none'
          }
        }
        this.innerHTML = main_section ? main_section.outerHTML : "";

        const sectionWrappers = doc.querySelectorAll(".section-wrapper");

        sectionWrappers.forEach((sectionWrapper, index) => {
          const target = document.querySelector(
            `.${STATIC_SECTION_TARGETS[index]}-${this.index}`
          );
          if (target) {
            target.innerHTML = sectionWrapper ? sectionWrapper.outerHTML : "";
            const _parent = target.closest(".feature-section");
            const _els = _parent?.querySelector(".static-feature-content");
            const show = !_els.textContent.trim();
            if (show) {
              _parent?.classList.add("hidden");
            } else {
              _parent?.classList.remove("hidden");
            }
          }
        });
      })
      .catch(() => {
        this.renderEmpty();
      });
  }

  renderEmpty() {
    this.innerHTML = "";
  }
}

customElements.define("static-compare-product-card", StaticCompareProductCard);

// Page state update (empty vs not)
document.addEventListener("DOMContentLoaded", () => {
  const products = loadStaticCompareProductsFromDOM();
  const compareProductsPage = document.querySelector(
    ".compare-products-container"
  );
  if (!compareProductsPage) return;
  if (products.length === 0) {
    compareProductsPage.classList.add("compare-container-empty");
  } else {
    compareProductsPage.classList.remove("compare-container-empty");
  }
});
